import {
  AlertIcon,
  ChakraProvider,
  UseToastOptions,
  extendTheme,
  theme,
} from '@cdl/heartbeat-react';
import React, { PropsWithChildren } from 'react';

const plataneTheme = extendTheme(theme, {
  styles: {
    global: {
      body: {
        bg: '#F7F8FA',
        color: 'neutral.900',
      },
      ':not(.chakra-dont-set-collapse) > .chakra-collapse': {
        overflow: 'initial !important',
      },
    },
  },
  colors: {
    purple: {
      500: '#849AFF',
    },
  },
});

export const defaultToastOptions: UseToastOptions = {
  status: 'info',
  isClosable: true,
  icon: <AlertIcon />,
  variant: 'subtle',
  position: 'top-right',
  duration: 5000, // ms
};

export const AppThemeProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <ChakraProvider
    theme={plataneTheme}
    toastOptions={{ defaultOptions: defaultToastOptions }}
  >
    {children}
  </ChakraProvider>
);
